/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import * as API from "../../http/api";

import { VerifyInfo, VerifyMirai, Validate } from "../modals";
import CustomerDocumentIdentity from "./../modals/CustomerDocumentIdentity";
import { IdentityManualCheckList } from "./IdentityManualCheckList";
import { openlightbox, closelightbox } from "../../util/Functions";
import { theme, customStyles5 } from "../../util/TableStyles";
import { noDataComponent } from "../../util/DataObject"
import { useStyles } from "../../util/ComponentStyles";

import { Carousel } from "react-responsive-carousel";
import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.min.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import { Typography, Box, Button, Grid } from "@mui/material";
import { Badge, RotateRight, RotateLeft, Minimize } from "@mui/icons-material";
import { ThemeProvider } from "@mui/material/styles";
import DataTable from "react-data-table-component";
import moment from "moment";
import "moment/locale/es";
import { FlexGrid, Card } from '@albo-ui/core'

const checklistItemsCatalog = [
	{text: '1. Leible y correcto (foto real de ID) frente', uuid: '058a7c0e-5fa3-413f-af6a-1a4e6175bd6d', done: false},
	{text: '2. Leible y correcto (foto real de ID) atras', uuid: '31521a03-0d31-4271-8f9d-40a5ed15f3b3', done: false},
	{text: '3. Leible y correcto (foto real y tipo selfie)', uuid: 'd08a0e2c-f352-4432-be2e-5b97ea3be155', done: false},
	{text: '4. La misma persona en las foto de ID y Selfie', uuid: 'ebe70f5e-c9d3-49e2-bd1b-5f2ee5974415', done: false},
	{text: '5. La persona no está en la Black List', uuid: '83d683c8-9690-4738-88d9-19ba8656fc09', done: false},
	{text: '6. El ID coincide con lista nominal', uuid: '9873b77e-2a9e-4faa-b255-c46f72b1f3a0', done: false},
	{text: '7. El nombre registrado tiene que ser igual que el en ID', uuid: '4e21918f-0fde-4a1a-9000-3f150f4bf4e0', done: false},
	{text: '8. El apellido registrado tiene que ser igual que el en ID', uuid: '302c406e-4076-4731-b751-738595d6daac', done: false},
	{text: '9. El género registrado tiene que ser igual que el en ID', uuid: 'b6c1f3b3-c859-462b-a7af-b2f5e2b89fe5', done: false},
	{text: '10. La fecha de nacimiento registrada tiene que ser igual que la en ID', uuid: '808da2fa-7405-4b00-8ea5-b1300f5c38f2', done: false},
	{text: '11. El CURP registrado tiene que ser igual que el en ID', uuid: 'a763427f-2ed8-428e-8525-ab86870551de', done: false},
	{text: '12. El RFC registrado tiene que ser igual que el en ID', uuid: 'e3715f04-a4bf-4b47-9132-95cb948ded05', done: false},
	{text: '13. El CURP registrado se validó correctamente en RENAPO', uuid: 'ff95a200-2e6c-4108-83b1-f96d5285c41d', done: false},
	{text: '14. El RFC registrado se validó correctamente en RENAPO', uuid: '6093ee39-c370-43cc-9eee-6cba325c3615', done: false}
]

const checklistItemsN1 = [
	{text: '1. La persona no está en la Black List', uuid: '83d683c8-9690-4738-88d9-19ba8656fc09', done: false},
	{text: '2. El CURP registrado se validó correctamente en RENAPO', uuid: 'ff95a200-2e6c-4108-83b1-f96d5285c41d', done: false},
	{text: '3. El RFC registrado se validó correctamente en RENAPO', uuid: '6093ee39-c370-43cc-9eee-6cba325c3615', done: false}
]

const Identity = (props) => {
  moment.locale("es");
  const history = useHistory();
  const clasess = useStyles();
	const [active, setActive] = useState(false);
	const [activeList, setActiveList] = useState(false);
	const [activeImage, setActiveImage] = useState(true);
	const [activeRisk, setActiveRisk] = useState(false);
	const [imgStyle, setImgStyle] = useState(false);
	const [showText, setShowText] = useState(false);
  
  const [n1, setN1] = useState(false);
  const [ocupacion, setOcupacion] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [customerJumio, setUserJumio] = useState(null);
  const [customerNubarium, setUserNubarium] = useState(null);
  const [checklistItems, setChecklistItems] = useState([]);
  const [enableManualCheckButton, setEnableManualCheckButton] = useState(false);
  const [test, setTest] = useState(1);
  const [all, setAll] = useState(false);

  const [imgCheck, setImgCheck] = useState({selfie: false, front: false, back: false});

  useEffect(() => {

    if(props.content.front){
      checkImage(props.content.front, "front")
    }
    if(props.content.selfie){
      checkImage(props.content.selfie, "selfie")
    } 
    if(props.content.back){
      checkImage(props.content.back, "back")
    }
    if(props.content.typeIdentity === "N1"){
      setN1(true)
      setChecklistItems(checklistItemsN1)
    } else {
      setN1(false)
      setChecklistItems(checklistItemsCatalog)
    }

    const readChecklist = async () => {
      const data = {customer_uuid: props.content.customer_uuid};
      props.changeLoader(true);
      let request = await API.service( "getManualChecklist", data, props.pos, props.changeAlert, props.changeLoader, history );
      props.changeLoader(false);

      if (request.data?.data?.message === null) {
        return;
      }

      let checklistItemsCopy = request.data?.data?.message?.checklist;
      setChecklistItems(checklistItemsCopy);

      if (checklistItemsCopy?.filter((item) => !item.done).length <= 0) {
        setEnableManualCheckButton(true);
        setAll(true);
      } else {
        setEnableManualCheckButton(false);
      }
    };
    if (props.config.actions?.indexOf("noCheckList") == -1) {
      readChecklist();
    }

    if(props.content.hasOwnProperty("clevelRisk")){
      if (props.content.clevelRisk[2].value === "3") {
        for (let i = 0; i < props.catalogs.economicActivities.length; i++) {
          if ( props.catalogs.economicActivities[i]["k"] == props.content.clevelRisk[4].value) {
            setOcupacion(props.catalogs.economicActivities[i]["v"]);
          }
        }
      } else {
        for (let i = 0; i < props.catalogs.occupations.length; i++) {
          if (props.catalogs.occupations[i]["k"] == props.content.clevelRisk[4].value) {
            setOcupacion(props.catalogs.occupations[i]["v"]);
          }
        }
      }
  
      for (let i = 0; i < props.catalogs.country.length; i++) {
        if (props.catalogs.country[i]["k"] == props.content.clevelRisk[5].value) {
          setCountry(props.catalogs.country[i]["v"]);
        }
      }

      for (let i = 0; i < props.catalogs.states.length; i++) {
        if (props.catalogs.states[i]["k"] == props.content.clevelRisk[6].value) {
          setState(props.catalogs.states[i]["v"]);
        }
      }
    }
  
    getMeta(props.content.front)
  }, [props.content]);

  const checkImage = async (url, type) => {
    props.changeLoader(true);
    let f = imgCheck
    var s = document.createElement("img");
    s.src = url

    if(s.src){ 
      s.onerror = await function(){
        f[type] = true
        setImgCheck(JSON.parse(JSON.stringify(f)));
        props.changeLoader(false);
      }
      s.onload = await function(){
        f[type] = false
        setImgCheck(JSON.parse(JSON.stringify(f)));
        props.changeLoader(false);
      }
    }
  }
  
  const getCuentaTypeFormat = (type) => {
    switch (type) {
      case "1": {
        return "Cliente Normal";
      }
      case "2": {
        return "Card In Hand";
      }
      case "3": {
        return "PM"; 
      }
      case "4": {
        return "PFAE";
      }
      default: {
        return "N/A";
      }
    }
  };

  const hasAction = (action) => {
    return props.config?.actions?.indexOf(action) > -1;
  };

	const colapse = () => {
    if (active) {
      setActive(false);
    } else {
      setActive(true);
    }
  };
	const colapseList = () => {
    if (activeList) {
      setActiveList(false);
    } else {
      setActiveList(true);
    }
  };
	const colapseImage = () => {
    if (activeImage) {
      setActiveImage(false);
    } else {
      setActiveImage(true);
    }
  };

  const colapseRisk = () => {
    if (activeRisk) {
      setActiveRisk(false);
    } else {
      setActiveRisk(true);
    }
  };

  const cLevelInit = async () => {
    props.changeLoader(true);
    let data = {
      page: 1,
      limit: 5,
    };

    let request = await API.service( "initCLevel", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status == 200) {
      if (request.data.data.response == "OK") {
        props.changeWidgets(request.data.data.widget);
      }
    } else {
      props.changeWidgets([]);
    }
    props.changeLoader(false);
  };

  const complianceInit = async (page) => {
    props.changeLoader(true);
    let widgetsCompliance = await API.service( "complianceInit", page, props.pos, props.changeAlert, props.changeLoader, history );
    if (widgetsCompliance.status == 200 && widgetsCompliance.data.data.response == "OK" ) {
      props.changeWidgets(widgetsCompliance.data.data.widget);
    } else {
      props.changeWidgets([]);
    }
    props.changeLoader(false);
  };

  const openModal = async (flag) => {
    props.changeLoader(true);
    let data = {
      flag: flag,
    };
    let request = await API.service( "openModalValidate", data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == "OK") {
      const as = (
        <Validate
          updateStatus={updateStatus}
          config={props.config}
          changeAlert={props.changeAlert}
          changeLoader={props.changeLoader}
          contentModal={request.data.data.widget[0]}          
          pep={String(props.widgets[2].content?.pep ? props.widgets[2].content?.pep : false)}
          key="validate"
        />
      );
      openlightbox(as);
    }
    props.changeLoader(false);
  };

  const updateStatus = async (flag, reason, files = [], comment = "", pep) => {
    if (!flag || !reason) {
      return;
    }

    props.changeLoader(true);
    let data = {
      customer: {
        uuid: props.content.customer_uuid,
      },
      validation: {
        result: {
          status: flag,
          reason: reason,
        },
      },
      files: files,
      comment: comment,
    };

    if(flag === "validated" || flag === "rejected"){
      data["validation"]["pep"] = JSON.parse(pep)
    }

    let updateInfo = await API.service( "manualCheckDefine", data, props.pos, props.changeAlert, props.changeLoader, history );

    if (updateInfo.status == 200) {
      if (updateInfo.data.data.response == "OK") {
        closelightbox();
        let message = "";
        switch (flag) {
          case "validated" && !hasAction("clevelRisk"):
            message = "Se validó correctamente";
            break;
          case "invalidated":
            message = "Se envío solicitud de documentos";
            break;
          case "rejected":
            message = "El cliente fue rechazado";
            break;
          case "validated" && hasAction("clevelRisk"):
            message = "Se aprobó correctamente";
            break;
          default:
            message = "";
            break;
        }
        props.updateStatusAction(true, message);
        if (props.content.origin == "complianceInit") {
          if (props.config.actions?.indexOf("noCheckList") > -1) {
            cLevelInit();
          } else {
            complianceInit(1);
          }
        } else {
          props.changeLoader(true);

          let request = await API.service( "addIdentity", props.content.customer_uuid, props.pos, props.changeAlert, props.changeLoader, history );
          if (request.status == 200 && request.data.data.response == "OK") {
            let newWidgets = [];
            let existe = false;
            for (let i = 0; i < props.widgets.length; i++) {
              if (props.widgets[i]["type"] == "identity") {
                newWidgets.push(request.data.data.widget[0]);
                existe = true;
              } else {
                newWidgets.push(props.widgets[i]);
              }
            }

            if (!existe) {
              newWidgets = [request.data.data.widget[0]].concat(newWidgets);
            }
            props.changeWidgets(newWidgets);
          }
          props.changeLoader(false);
        }
      } else {
        props.changeLoader(false);
      }
    } else {
      props.changeLoader(false);
    }
  };

  const verifyInfo = async (type) => {
    props.changeLoader(true);
    let data = {
      type: type,
      customer_uuid: props.content.customer_uuid,
      //id: props.content.originalFront
    };

    if (type == "nubarium") {
      data["id"] = props.content.originalFront;
    }

    if (type == "validateJumio") {
      data["frontsideImage"] = props.content.originalFront;
      data["faceImage"] = props.content.originalSelf;
      data["country"] = "MEX";
      data["idType"] = "PASSPORT";
      data["merchantIdScanReference"] = "67233-tfrgyt-677445-sdxcth-wwwretr-53223545:215216245164321563426156213462";
      data["customerId"] = "PVIS120720216767867TST";
    }

    if (type == "verifyJumio") {
      data["token_jumio"] = props.content.token_jumio;
    }

    let request = await API.service( "verifyInfo", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status == 200 && request.data.data.response == "OK") {
      if (type == "nubarium") {
        const as = (
          <VerifyInfo
            contentModal={request.data.data.widget[0].content}
            pos={props.pos}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            key="verifyInfo"
          />
        );
        openlightbox(as);
      }

      if (type == "validateJumio") {
        props.changeAlert(true, "OK", request.data.data.message);
        let widgs = props.widgets;
        for (let i = 0; i < widgs.length; i++) {
          if (widgs[i]["type"] == "identity") {
            widgs[i]["content"]["token_jumio"] = request.data.content;
          }
        }
        props.changeWidgets(JSON.parse(JSON.stringify(widgs)));
      }

      if (type == "verifyJumio") {
        if (request.data.data.widget.length > 0) {
          let widgs = props.widgets;
          for (let i = 0; i < widgs.length; i++) {
            if (widgs[i]["type"] == "identity") {
              widgs[i]["content"]["token_jumio"] = "";
            }
          }

          props.changeWidgets(JSON.parse(JSON.stringify(widgs)));
          const as = (
            <VerifyInfo
              contentModal={request.data.data.widget[0].content}
              pos={props.pos}
              changeAlert={props.changeAlert}
              changeLoader={props.changeLoader}
              key="verifyInfo"
            />
          );
          openlightbox(as);
        } else {
          props.changeAlert(true, "OK", request.data.data.message);
        }
      }
    }
    props.changeLoader(false);
  };

  const mirai = async () => {
    props.changeLoader(true);
    let dataMirai = {
      customer_uuid: props.content.customer_uuid,
    };

    let request = await API.service( "identityMirai", dataMirai, props.pos, props.changeAlert, props.changeLoader, history );
    props.changeLoader(false);
    if (request.status === 200 && request.data.data.response === "OK") {
      const as = (
        <VerifyMirai
          contentModal={request.data.data.message}
          pos={props.pos}
          changeAlert={props.changeAlert}
          changeLoader={props.changeLoader}
          key="verifyMirai"
        />
      );
      openlightbox(as);
    }
  };

  const allImge = () => {
    let contentModal = {
      front: props.content.front,
      back: props.content.back,
      self: props.content.selfie,
      Identity: props.content.typeIdentity,
    };
    const modalReversaaUsuario = (
      <CustomerDocumentIdentity
        contentModal={contentModal}
        changeAlert={props.changeAlert}
        changeLoader={props.changeLoader}
        pos={props.pos}
        history={history}
      />
    );
    openlightbox(modalReversaaUsuario);
  };

  const checklistChangeHandler = async (uuid, done) => {
    let copy = test + 1;
    let copyCollection = checklistItems;
    let index = checklistItems.findIndex((item) => item.uuid === uuid);
    let copyItem = checklistItems[index];
    copyItem.done = done;
    copyCollection[index] = copyItem;

    const data = {
      checklist: copyCollection,
      customer_uuid: props.content.customer_uuid,
    };
    props.changeLoader(true);
    let request = await API.service( "saveChecklist", data, props.pos, props.changeAlert, props.changeLoader, history );
    props.changeLoader(false);
    setTest(copy);
    if (isChecklistComplete()) {
      setEnableManualCheckButton(true);
    } else {
      setEnableManualCheckButton(false);
    }
  };

  const checklistAll = async () => {
    let copyCollection = checklistItems;

    if (!all) {
      setAll(true);
      copyCollection.map((i) => {
        if (!i.done) {
          i.done = true;
        }
      });
    } else {
      setAll(false);
      copyCollection.map((i) => {
        if (i.done) {
          i.done = false;
        }
      });
    }

    const data = {
      checklist: copyCollection,
      customer_uuid: props.content.customer_uuid,
    };

    props.changeLoader(true);
    let request = await API.service( "saveChecklist", data, props.pos, props.changeAlert, props.changeLoader, history );
    props.changeLoader(false);

    if (isChecklistComplete()) {
      setEnableManualCheckButton(true);
    } else {
      setEnableManualCheckButton(false);
    }
  };

  const isChecklistComplete = () => {
    return checklistItems.filter((item) => !item.done).length <= 0;
  };

	const columns = [		
		{ selector: (row, index) => index + 1, name: "No.", width:"10%", wrap: true, sortable: true, center: true },
		{ selector: (row) => row.validation_date && typeof row.validation_date == "string" ? moment(new Date(row.validation_date?.substring(0, 10).replace(/-/g, "/"))).format("L") : moment(new Date(row.validation_date?.$date)).format("L"), name: "Fecha de verificación", wrap: true, sortable: true },
		{ selector: (row) => row.statusParse, name: "Resultado", wrap: true, sortable: true },
		{ selector: (row) => row.agent?.name, name: "Agente verificador", wrap: true, sortable: true },
		{ selector: (row) => row.data?.hasOwnProperty("Front/ML/ElectorKey") && row.data["Front/ML/ElectorKey"]
        ? row.data["Front/ML/ElectorKey"]
        : row.data?.hasOwnProperty("Front/MRZ/DocumentNumber") && row.data["Front/MRZ/DocumentNumber"]
        ? row.data["Front/MRZ/DocumentNumber"] : "N/A"
			, name: "No. identificación", wrap: true, sortable: true },
	] 

	const info = [
    { key: "DateOfExpiry", label: "Vigencia Identificación" },
    { key: "reason", label: "Detalle resultado" },
    { key: "Front/ML/Folio", label: "Folio" },
    { key: "Front/MRZ/MrzText", label: "Texto pasaporte" },
  ];    

	const viewInfo = (item) => {
		return (
			<Box className="dataBlock">
				{info.map((i) => {	
					if(item.data[i.key] || item.data?.data[i.key]){
						return (
							<div key={i.key} className="report_display">
								<label className="neutral" style={{width: "20%"}}>{i.label}</label>
								<p>{item.data[i.key] || item.data?.data[i.key] || "N/A"}</p>
							</div>
						)
					}
				})}
			</Box>
		)
	};

  function getMeta(url){   
    const img = new Image();
    img.addEventListener("load", function() { 
      if(this.naturalHeight > this.naturalWidth){
        // const scale = this.naturalWidth > this.naturalHeight ? this.naturalHeight / this.naturalWidth : 1
        // const yshift = -100 * scale
        // const style = {transform: "rotate(90deg) translateY("+yshift+"%) scale("+scale+")", transformOrigin: "top left"}
        setImgStyle(true)
        setShowText(true)
      } else {
        setImgStyle(false)
        setShowText(false)
      }
    });
    img.src = url;
  }

  const rotateImage = () => {
    if(imgStyle){
      setImgStyle(false)
    } else {
      setImgStyle(true)
    }
  }

  return (
    <Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: "white", marginBottom: 15}}>
      <FlexGrid container fullWidth justify="space-between">
				<FlexGrid item>
					<Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}} fontWeight={600}>
						<Badge sx={{ marginRight: 1 }}/> Identificación
					</Typography>
				</FlexGrid>
			</FlexGrid>

      <Grid container className={clasess.gridContainer1}>      
        <Grid item xs={9}>
          <h4>{!activeImage ? "Ver " : "Ocultar " }{!n1 ? "Imágenes": "Acciones"}  <i className={!activeImage ? `tap ibon-chevron-down`: `tap ibon-chevron-up`} onClick={colapseImage.bind(this, false)}/></h4>
        </Grid>
        {props.content.back && activeImage && (
          <Grid item xs={3}>
            <h4 style={{ paddingLeft: "23%", cursor: "pointer" }}><a onClick={allImge}>Ver todas las imágenes</a></h4>
          </Grid>
        )}					
      </Grid>

			{activeImage && (
				<Box style={{ display: "flex", marginTop: !n1 ? "4%" : "1%"}}>
					<Grid container spacing={5} ml={0} mt={0} pt={0} sx={{maxHeight: imgStyle ? "340px" : "auto"}}>
            {!n1 &&
              <Grid item xs={4} pt={"0px !important"} className="selfieIdSmall" >
                <InnerImageZoom src={props.content.selfie} />
                {imgCheck.selfie && <Grid item color={"red"}>La selfie no se encuentra disponible</Grid>}
              </Grid>
            }
						
						{!props.content.back && !n1 && (
							<Grid item xs={5} pt={"0px !important"} className="selfieIdSmall">
                {showText && (
                  <Grid item>
                    <h4 className={clasess.infoH4}>Girar Imagen {imgStyle ? <RotateLeft onClick={rotateImage.bind(this, false)} cursor="pointer" /> : <RotateRight onClick={rotateImage.bind(this, false)} cursor="pointer" />}</h4>
                  </Grid>
                )}       
                <InnerImageZoom className={imgStyle ? clasess.imageRotate : ""} src={props.content.front} />
                {imgCheck.front && <Grid item color={"red"}>La imagen frontal no se encuentra disponible</Grid>}
							</Grid>
						)}
						{props.content.back && (
							<Grid item xs={5} pt={"0px !important"} className="selfieIdSmall">
								<Carousel showThumbs={false}>
                  <InnerImageZoom src={props.content.front} />
                  {imgCheck.front && <Grid item color={"red"}>La imagen frontal no se encuentra disponible</Grid>}    
                  <InnerImageZoom src={props.content.back} />
                  {imgCheck.back && <Grid item color={"red"}>La imagen trasera no se encuentra disponible</Grid>}
								</Carousel>
							</Grid>
						)}
						<Grid item xs={!n1 ? 3 : 10} pt={"0px !important"}>
							<Box style={{display: "flex", flexDirection: !n1 ? "column" : "row"}}>
								{props.config?.actions?.indexOf("noCheckList") == -1 && !n1 && (
									<Button onClick={openModal.bind(this, "invalidated")} variant="outlined" className={clasess.buttonOption}>Solicitar Documentos</Button>
								)}
								<Button onClick={openModal.bind(this, "rejected")} variant="outlined" className={clasess.buttonOption}>Rechazar</Button>
								{props.config?.actions?.indexOf("assignValidate") > -1 && (
									<Button onClick={openModal.bind(this, "waiting_for_auth")} variant="outlined" className={clasess.buttonOption}>Pendiente por validar</Button>
								)}
           
                <Button onClick={openModal.bind(this, "validated")} variant="outlined" className={clasess.buttonOption}>Aprobar</Button>
								{props.content.typeIdentity == "Pasaporte" && !props.content.token_jumio && props.config.actions?.indexOf("noCheckList") == -1 && (
									<Button onClick={verifyInfo.bind(this, "validateJumio")} variant="outlined" className={clasess.buttonOption}>Validar Pasaporte</Button>
								)}
								{props.content.typeIdentity == "Pasaporte" && props.content.token_jumio && props.config.actions?.indexOf("noCheckList") == -1 && (
									<Button onClick={verifyInfo.bind(this, "verifyJumio")} variant="outlined" className={clasess.buttonOption}>Verificar estatus Pasaporte</Button>
								)}
								{props.content.typeIdentity == "INE" && props.config.actions?.indexOf("noCheckList") == -1 && (
									<Button onClick={verifyInfo.bind(this, "nubarium")} variant="outlined" className={clasess.buttonOption}>Validar INE</Button>
								)}
								{props.config.actions?.indexOf("noCheckList") == -1 && (
									<Button onClick={mirai} variant="outlined" className={clasess.buttonOption}>Validar RFC y CURP</Button>
								)}	              

								{customerJumio != null && customerJumio.jumio.passaport.value && (
									<a className="identity-valid">Pasaporte validado</a>
								)}
								{customerJumio != null &&	!customerJumio.jumio.passaport.value && (
									<a className="identity-nubarium-error">Pasaporte inválido</a>
								)}
								{customerNubarium != null && customerNubarium.nubarium.status && (
									<a className="identity-valid">INE validado</a>
								)}
								{customerNubarium != null && !customerNubarium.nubarium.status && (
									<a className="identity-nubarium-error">INE inválido</a>
								)}
                <Button href="https://listanominal.ine.mx/scpln/" target="_blank" rel="noopener noreferrer" variant="outlined" className={clasess.buttonOption}>
                  Lista nominal
                </Button>
							</Box>
						</Grid>
					</Grid>
				</Box>
			)}
			
			{activeList && (
				<Box style={{padding: "0 32px"}}>
					<div className="identity-checklist-row">
						<input type="checkbox" checked={all} onClick={() => checklistAll()}></input>
						<label>{all ? "Desmarcar todo" : "Seleccionar todo"}</label>
					</div>
            <div className="checklist-container">
              <div className="identity-checklist-column">
                <IdentityManualCheckList
                  todos={checklistItems.slice(0, 7)}
                  onCheckHandler={checklistChangeHandler}
                  />
              </div>

              {!n1 &&
                <div className="identity-checklist-column">
                  <IdentityManualCheckList
                    todos={checklistItems.slice(7, 14)}
                    onCheckHandler={checklistChangeHandler}
                  />
                </div>
              }
            </div>
				</Box>
			)}

			<Grid item xs={12} className={clasess.gridItem1}>      
        <h4>{!active ? "Ver " : "Ocultar " }Detalle Verificación  <i className={!active ? `tap ibon-chevron-down`: `tap ibon-chevron-up`} onClick={colapse.bind(this, false)}/></h4>
      </Grid>
			{active && (
				<Box style={{display: "flex", width: "32%", padding: "3px 32px" }} >
					<Button className={clasess.buttonOption} style={{marginRight: "5%", width: "40%"}} href={props.content.validations[0].watchlist_url} target="_blank" rel="noopener noreferrer" >
						Watchlist
					</Button>
				</Box>

			)}
			{active && (		
				<div style={{ width: "90%", margin: "auto", marginBottom: "35px" }}>
					<ThemeProvider theme={theme} >
						<DataTable
							columns={columns}
							data={props.content.validations}
							expandableRows
							expandOnRowClicked={false}
							expandableRowsComponent={viewInfo}
							customStyles={customStyles5}
              noDataComponent={noDataComponent}
							/>
					</ThemeProvider>
				</div>
			)}

      {/* C-Level -----------------------------------*/}
      {hasAction("clevelRisk") && props.content?.clevelRisk &&
				<Grid item xs={12} className={clasess.gridItem1} >      
					<h4>{!activeRisk ? "Ver " : "Ocultar " }Matriz de Riesgo  <i className={!activeRisk ? `tap ibon-chevron-down`: `tap ibon-chevron-up`} onClick={colapseRisk.bind(this, false)}/></h4>
				</Grid>
			}
			
			{activeRisk && (
        <Grid container spacing={4} wrap={"wrap"} style={{padding: "22px 32px"}}>
          {props.content?.clevelRisk?.map((item) => {
            return (
              <Grid key={item.key} item container spacing={2} md={6} xs={6} style={{paddingTop: "2px"}}>
                {(() => { switch (item.key) {
                  case "2":
                    return <Grid item xs={12} >{<Minimize />} <span style={{color: "#3743aa"}}>{item.label}: </span><span >{getCuentaTypeFormat(item.value) || "N/A"}</span></Grid>
                  case "3":
                    return <Grid item xs={12} >{<Minimize />} <span style={{color: "#3743aa"}}>{item.label}: </span><span >{(moment().diff(moment(item.value, 'YYYYMMDD'), 'years')) + " años"  || "N/A"}</span></Grid>
                  case "4":
                    return <Grid item xs={12} >{<Minimize />} <span style={{color: "#3743aa"}}>{item.label}: </span><span >{ocupacion || "N/A"}</span></Grid>
                  case "5":
                    return <Grid item xs={12} >{<Minimize />} <span style={{color: "#3743aa"}}>{item.label}: </span><span >{country || "N/A"}</span></Grid>
                  case "6":
                    return <Grid item xs={12} >{<Minimize />} <span style={{color: "#3743aa"}}>{item.label}: </span><span >{state || "N/A"}</span></Grid>
                  default:
                    return <Grid item xs={12}>{<Minimize />} <span style={{color: "#3743aa"}}>{item.label}: </span><span >{item.value || "N/A"}</span></Grid>
                }})()}
              </Grid>
            )
          })}
        </Grid>
			)}
    </Card>
  );
};

export default Identity;
